<template>
  <div id="Debtor" dir="rtl">
    <loading v-if="loadingRender"></loading>
    <panel
      class="no-print"
      Title="فرم برداشت وجه"
      Des="از طریق این فرم می‌توانید درخواست برداشت وجه خود را اعلام کنید"
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <net-pa-card class="no-print">
      <template slot="header">
        <h6 class="text-right">
          <i class="fas fa-hand-holding-usd"></i>
          فرم برداشت وجه
        </h6>
      </template>
      <template slot="content">
        <div class="Debtor-form">
          <!-- حساب مبدأ -->
          <div class="Debtor-flow">
            <div class="Debtor-field">
              <label class="Debtor-label" for="cmbTaahodat">انتخاب حساب</label>
              <select
                v-if="IsLoad"
                name="cmbTaahodat"
                id="cmbTaahodat"
                class="form-control Pointer"
                v-model="Resultcmb"
                @change="CheckIfDelayed(Resultcmb)"
              >
                <option selected value="-1">-- انتخاب حساب --</option>
                <option
                  v-for="item in this.ListModel"
                  :key="item.id"
                  :value="item"
                >
                  {{ item.vcodeDesNo }} {{ item.nameFamily }}
                </option>
              </select>
              <div v-else class="Debtor-skeleton">
                <i class="fas fa-circle-notch fa-spin"></i>
                در حال بارگذاری حساب‌ها ...
              </div>
            </div>

            <div class="Debtor-balance" :class="{ 'is-empty': withdrawable === null }">
              <span class="Debtor-balance__label">مبلغ قابل برداشت</span>
              <strong class="Debtor-balance__value">
                <template v-if="withdrawable !== null">
                  {{ $Comma3ragham(withdrawable) }}
                  <small>{{ $GetVahedPool() }}</small>
                </template>
                <template v-else>—</template>
              </strong>
            </div>

            <div v-if="dailyLimit" class="Debtor-limit">
              <div class="Debtor-limit__head">
                <span>سقف برداشت روزانه {{ dailyLimit.title }}</span>
                <b>{{ $Comma3ragham(dailyLimit.max) }}</b>
              </div>
              <div class="Debtor-progress">
                <span
                  :class="'is-' + dailyLimit.level"
                  :style="{ width: dailyLimit.percent + '%' }"
                ></span>
              </div>
              <div class="Debtor-limit__meta">
                <span>
                  برداشت امروز:
                  <b>{{ $Comma3ragham(dailyLimit.used) }}</b>
                </span>
                <span class="Debtor-limit__remaining">
                  باقیمانده:
                  <b>{{ $Comma3ragham(dailyLimit.remaining) }}</b>
                </span>
              </div>
            </div>

            <!-- اطلاعات مقصد -->
            <template v-if="$session.get('CustCode') != 801">
            <div class="Debtor-field">
              <span class="Debtor-label">روش انتقال</span>
              <div class="Debtor-segmented" role="radiogroup">
                <label
                  v-if="
                    $session.get('CustCode') != 561 &&
                    $session.get('CustCode') != 866 &&
                    $session.get('CustCode') != 948 &&
                    $session.get('CustCode') != 953
                  "
                  class="Debtor-segment"
                  :class="{ 'is-active': NoeEnteghal == 'Card' }"
                >
                  <input
                    type="radio"
                    name="NoeEnteghal"
                    value="Card"
                    v-model="NoeEnteghal"
                    @click="ShowList = false"
                  />
                  <i class="far fa-credit-card"></i>
                  <span>کارت</span>
                </label>
                <label
                  v-if="$session.get('CustCode') != 934"
                  class="Debtor-segment"
                  :class="{ 'is-active': NoeEnteghal == 'Satna' }"
                >
                  <input
                    type="radio"
                    name="NoeEnteghal"
                    value="Satna"
                    v-model="NoeEnteghal"
                    @click="ShowList = false"
                  />
                  <i class="fas fa-university"></i>
                  <span>ساتنا</span>
                </label>
                <label
                  v-if="$session.get('CustCode') != 934"
                  class="Debtor-segment"
                  :class="{ 'is-active': NoeEnteghal == 'Sheba' }"
                >
                  <input
                    type="radio"
                    name="NoeEnteghal"
                    value="Sheba"
                    v-model="NoeEnteghal"
                    @click="ShowList = false"
                  />
                  <i class="fas fa-exchange-alt"></i>
                  <span>پایا</span>
                </label>
              </div>
            </div>

            <!-- شماره کارت -->
            <div v-if="NoeEnteghal == 'Card'" class="Debtor-field">
              <div class="Debtor-label-row">
                <span class="Debtor-label">شماره کارت</span>
                <button
                  type="button"
                  class="Debtor-link-btn"
                  @click="toggleSavedList"
                >
                  <i class="fa fa-list"></i>
                  کارت‌های ذخیره‌شده
                </button>
              </div>
              <div class="Debtor-cardnum" dir="ltr">
                <input
                  type="number"
                  inputmode="numeric"
                  autocomplete="off"
                  placeholder="0000"
                  class="form-control text-center"
                  id="FirstInput"
                  @input="
                    First4Digit.length >= 4
                      ? ((First4Digit = First4Digit.slice(0, 4)),
                        jumpTo('SecondInput'))
                      : void 0
                  "
                  v-model="First4Digit"
                />
                <input
                  type="number"
                  inputmode="numeric"
                  autocomplete="off"
                  placeholder="0000"
                  class="form-control text-center"
                  id="SecondInput"
                  @input="
                    Second4Digit.length >= 4
                      ? ((Second4Digit = Second4Digit.slice(0, 4)),
                        jumpTo('ThirdInput'))
                      : checkBankName()
                  "
                  v-model="Second4Digit"
                />
                <input
                  type="number"
                  inputmode="numeric"
                  autocomplete="off"
                  placeholder="0000"
                  class="form-control text-center"
                  id="ThirdInput"
                  @input="
                    Third4Digit.length >= 4
                      ? ((Third4Digit = Third4Digit.slice(0, 4)),
                        jumpTo('lastInput'))
                      : void 0
                  "
                  v-model="Third4Digit"
                />
                <input
                  type="number"
                  inputmode="numeric"
                  autocomplete="off"
                  placeholder="0000"
                  class="form-control text-center"
                  id="lastInput"
                  @input="
                    Forth4Digit.length >= 4
                      ? ((Forth4Digit = Forth4Digit.slice(0, 4)),
                        EstelamCart())
                      : void 0
                  "
                  v-model="Forth4Digit"
                />
              </div>
              <div
                class="Debtor-bank"
                v-if="
                  $session.get('CustCode') == 934 ||
                  $session.get('CustCode') == 8002
                "
              >
                <div class="d-none" id="Bank">بانک مقصد :</div>
                <div class="d-none" id="BankName">
                  {{ bankSelected.bankName }}
                </div>
                <div class="d-none" id="Error">
                  <div
                    class="alert alert-danger font-weight-normal text-center mb-0"
                  >
                    امکان انتقال فقط به کارت های با مقصد ملی ، سپه و کشاورزی
                    امکان پذیر می باشد
                  </div>
                </div>
              </div>
            </div>

            <!-- شماره شبا -->
            <div
              v-if="NoeEnteghal == 'Sheba' || NoeEnteghal == 'Satna'"
              class="Debtor-field"
            >
              <div class="Debtor-label-row">
                <span class="Debtor-label">شماره شبا</span>
                <button
                  type="button"
                  class="Debtor-link-btn"
                  @click="toggleSavedList"
                >
                  <i class="fa fa-list"></i>
                  شبا‌های ذخیره‌شده
                </button>
              </div>
              <div class="Debtor-sheba" dir="ltr">
                <span class="Debtor-sheba__prefix">IR</span>
                <input
                  type="number"
                  inputmode="numeric"
                  autocomplete="off"
                  placeholder="24 رقم"
                  @keypress="
                    ShowEstelam = false;
                    NameSahebHesab = '';
                  "
                  @input="
                    ShebaNo.length > 24
                      ? ((ShebaNo = ShebaNo.slice(0, 24)),
                        jumpTo('NameSahebHesab'))
                      : void 0
                  "
                  class="form-control"
                  v-model="ShebaNo"
                />
                <button
                  type="button"
                  class="Debtor-sheba__inquiry"
                  title="استعلام شماره شبا"
                  @click="Estelam"
                >
                  <i class="fa fa-search"></i>
                  <span>استعلام</span>
                </button>
              </div>
              <small
                v-if="$GetIsEstelamSheba() === 'true'"
                class="Debtor-note"
              >
                <i class="fas fa-info-circle"></i>
                بعد از وارد کردن شماره شبا، استعلام را انجام دهید.
              </small>
            </div>

            <!-- لیست ذخیره شده -->
            <div v-if="ShowList" class="Debtor-saved" :key="KEY">
              <div class="Debtor-saved__head">
                لیست
                <span v-if="NoeEnteghal == 'Card'">کارت‌های</span>
                <span v-else>شبا‌های</span>
                ذخیره‌شده
              </div>
              <input
                type="text"
                class="form-control mb-2"
                v-model="SearchShebaOrCard"
                :placeholder="
                  NoeEnteghal == 'Card'
                    ? 'جستجو در شماره کارت یا نام صاحب...'
                    : 'جستجو در شماره شبا یا نام صاحب...'
                "
              />
              <div class="Debtor-saved__list">
                <div
                  v-if="FilteredListShebaOrCard.length == 0"
                  class="Debtor-saved__empty"
                >
                  موردی یافت نشد
                </div>
                <div
                  class="Debtor-saved__item"
                  :class="{ 'is-selected': item.selected == true }"
                  v-for="(item, key) in FilteredListShebaOrCard"
                  :key="key"
                >
                  <div class="Debtor-saved__info">
                    <div class="Debtor-saved__num" dir="ltr">
                      <span v-if="NoeEnteghal != 'Card'">IR</span
                      >{{ item.shebaOrCardNum }}
                    </div>
                    <div class="Debtor-saved__owner">
                      {{ item.sahebShebaOrCard }}
                    </div>
                  </div>
                  <div class="Debtor-saved__actions">
                    <button
                      v-if="item.selected != true"
                      type="button"
                      class="Debtor-icon-btn is-select"
                      title="انتخاب"
                      @click="
                        SelectShebaOrCard(
                          item.id,
                          NoeEnteghal != 'Card' ? true : false,
                        )
                      "
                    >
                      <i class="fa fa-check"></i>
                    </button>
                    <span v-else class="Debtor-icon-btn is-done">
                      <i class="fa fa-check"></i>
                    </span>
                    <button
                      type="button"
                      class="Debtor-icon-btn is-remove"
                      title="حذف"
                      @click="RemoveShebeOrCard(item)"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- نتیجه استعلام -->
            <div v-if="ShowEstelam" class="Debtor-estelam" :key="KEY">
              <div class="Debtor-estelam__row">
                <span>شماره حساب</span>
                <b dir="ltr">{{ EstelamData.accountNumber }}</b>
              </div>
              <div class="Debtor-estelam__row">
                <span>مشخصات حساب</span>
                <b>{{ EstelamData.accountComment }}</b>
              </div>
              <div class="Debtor-estelam__row">
                <span>صاحبان حساب</span>
                <div class="Debtor-estelam__holders">
                  <template v-for="(item, index) in EstelamData.holders">
                    <em v-if="item.firstName != ''" :key="index">{{
                      item.firstName + " " + item.lastName
                    }}</em>
                  </template>
                </div>
              </div>
            </div>

            <div class="Debtor-field">
              <label class="Debtor-label" for="NameSahebHesab"
                >نام صاحب حساب</label
              >
              <input
                id="NameSahebHesab"
                type="text"
                v-model="NameSahebHesab"
                placeholder="نام و نام خانوادگی"
                @keyup="$BlockSuspiciousInput($event, 50)"
                @keypress="$BlockSuspiciousInput($event, 50)"
                class="form-control"
                :disabled="
                  $session.get('CustCode') == 934 || ShowEstelam == true
                "
              />
            </div>

            <div class="Debtor-field Debtor-switch">
              <div class="custom-control custom-switch">
                <input
                  type="checkbox"
                  class="custom-control-input InputText"
                  v-model="SaveShebaOrCard"
                  id="SaveShebaOrCard"
                />
                <label
                  class="custom-control-label Pointer"
                  for="SaveShebaOrCard"
                  v-if="NoeEnteghal == 'Card'"
                  >ذخیره اطلاعات کارت برای دفعات بعد</label
                >
                <label
                  class="custom-control-label Pointer"
                  for="SaveShebaOrCard"
                  v-else
                  >ذخیره اطلاعات شبا برای دفعات بعد</label
                >
              </div>
            </div>
            </template>

            <!-- مبلغ -->
            <div class="Debtor-field">
              <label class="Debtor-label" for="txtMablagh"
                >مبلغ برداشت ({{ $GetVahedPool() }})</label
              >
              <div class="Debtor-amount">
                <input
                  type="text"
                  ref="txtMablagh"
                  id="txtMablagh"
                  tabindex="1"
                  inputmode="numeric"
                  autocomplete="off"
                  placeholder="0"
                  dir="ltr"
                  class="form-control 3ragham Debtor-amount__input"
                  v-model="MabBardasht"
                  @keyup="$BlockSuspiciousInput($event, 30)"
                  @keypress="$BlockSuspiciousInput($event, 30)"
                />
                <span class="Debtor-amount__unit">{{ $GetVahedPool() }}</span>
              </div>
              <div class="Debtor-amount__foot">
                <span class="Debtor-amount__words">
                  <template v-if="MabBardasht">{{ Mab2persian }}</template>
                </span>
                <button
                  v-if="withdrawable > 0"
                  type="button"
                  class="Debtor-link-btn"
                  @click="fillMaxAmount"
                >
                  حداکثر مبلغ
                </button>
              </div>
            </div>

            <div v-if="$session.get('CustCode') == 866" class="Debtor-field">
              <label class="Debtor-label" for="DebtorDescription"
                >توضیحات (اختیاری)</label
              >
              <textarea
                id="DebtorDescription"
                class="form-control"
                v-model="Description"
                rows="3"
              ></textarea>
            </div>

            <!-- تایید نهایی -->
            <div class="Debtor-field">
              <CaptchaBox
                ref="captchaRef"
                @update="onCaptchaValid"
              ></CaptchaBox>
            </div>

            <button
              v-if="!twoLevel"
              type="button"
              :disabled="!CaptchaValid"
              class="Debtor-submit"
              @click="SabtBardasht(TaahodatId)"
            >
              <i class="fas fa-check-circle"></i>
              {{ GetMablagh }}
            </button>
            <button
              id="CloseModal"
              class="btn btn-danger w-75 d-none"
              data-dismiss="modal"
            ></button>

            <div v-if="twoLevel == true" class="Debtor-twostep">
              <label class="Debtor-label" for="DebtorTwoStep"
                >رمز پیامک شده را وارد کنید</label
              >
              <div class="Debtor-twostep__row">
                <input
                  id="DebtorTwoStep"
                  v-model="twstepCode"
                  type="number"
                  inputmode="numeric"
                  class="form-control text-center"
                />
                <button
                  type="button"
                  @click="CheckCode"
                  class="Debtor-submit Debtor-submit--sm"
                >
                  تایید
                </button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </net-pa-card>
  </div>
</template>
<script>
import Num2persian from "num2persian";
import loading from "../Tools/NetPa/Loading.vue";
import ModalCustom from "../Tools/ModalCustom.vue";
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import Panel from "../Tools/NetPa/Panel.vue";
import SelectCombo from "@/components/Tools/SelectCombo.vue";
import CaptchaBox from "../CmpLogin/CaptchaBox.vue";

export default {
  data() {
    return {
      captchaText: "",
      captchaId: "",
      CaptchaValid: false,
      disable: false,
      listBank: [
        { code: "5892-10", bankName: "بانک سپه" },
        { code: "6037-99", bankName: "بانک ملی ایران" },
        { code: "6037-70", bankName: "بانک کشاورزی" },
        { code: "6392-17", bankName: "بانک کشاورزی" },
      ],
      bankSelected: {},
      isLicenseDebtor: true,
      twstepCode: "",
      twoLevel: false,
      EstelamData: {
        accountNumber: "",
        holders: [{ firstName: "", lastName: "" }],
      },
      tblBankId: null,
      ShowList: false,
      ShowEstelam: false,
      KEY: 0,
      First4Digit: "",
      Second4Digit: "",
      Third4Digit: "",
      Forth4Digit: "",
      MabBardasht: "",
      NameSahebHesab: "",
      BankName: "",
      ShebaNo: null,
      CardNo: null,
      withdrawalIfLoanIsDelayed: false,
      selectKey: -1,
      NoeEnteghal: "Card",
      DataAxios: {
        ArryfildValue: "",
        Method: "Post",
        Action: "EnteghalVajh",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxios_cmbTaahodat: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxios_SahebHesab: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat/TaahodatSahebHesab",
        Token: this.$session.get("TokenNetPa"),
      },
      IsLoad: false,
      Resultcmb: null,
      rows: [],
      columns: [
        {
          label: "id",
          name: "id",
          visibility: false,
        },
        {
          label: "ردیف",
          name: "row",
        },

        {
          label: "عنوان حساب",
          name: "DesNoe",
        },
        {
          label: "کد حساب",
          name: "VCode",
        },
        {
          label: "مبلغ برداشت",
          name: "Bestan",
        },
        {
          label: "زمان تراکنش",
          name: "ZamanInsert",
        },
        {
          label: "تاریخ سند",
          name: "TarixSanad",
        },
        {
          label: "کد رهگیری",
          name: "CodeRahgiri",
        },
        {
          label: "شرح برداشت",
          name: "SharhSanad",
        },
      ],
      config: {
        pagination: true,
        pagination_info: false,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: "",
        card_mode: false,
        global_search: {
          placeholder: " جستجو",
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: {
        table: "table-bordered table-striped table-sm ",
      },
      loadingRender: false,
      ListModel: null,
      ListModelSahebHesab: null,
      SaveShebaOrCard: false,
      ListSheba: [],
      ListCard: [],
      SearchShebaOrCard: "",
      Description: "",
    };
  },
  components: {
    NetPaCard,
    Panel,
    loading,
    ModalCustom,
    SelectCombo,
    CaptchaBox,
  },
  props: ["TaahodatId", "GhebelBardasht"],
  updated() {
    this.$PutCommatoInput();
  },
  computed: {
    Mab2persian() {
      var Mab = this.MabBardasht.replace(/,/g, "");
      Mab = this.$b_ToPersianNumber(Mab);
      return " مبلـغ " + Num2persian(Mab) + " " + this.$GetVahedPool();
    },
    GetMablagh() {
      var Mab = this.MabBardasht.replace(/,/g, "");
      Mab = this.$b_ToPersianNumber(Mab);
      return (
        " برداشــت " + this.$Comma3ragham(Mab) + " " + this.$GetVahedPool()
      );
    },
    FilteredListShebaOrCard() {
      const list = this.NoeEnteghal === "Card" ? this.ListCard : this.ListSheba;
      const q = (this.SearchShebaOrCard || "").trim();
      if (!q) return list;
      const lower = q.toLowerCase();
      return list.filter(
        (item) =>
          (item.shebaOrCardNum &&
            item.shebaOrCardNum.toLowerCase().includes(lower)) ||
          (item.sahebShebaOrCard &&
            item.sahebShebaOrCard.toLowerCase().includes(lower)),
      );
    },
    hasCardDailyLimit() {
      return (
        this.Resultcmb &&
        this.Resultcmb !== -1 &&
        this.Resultcmb.maxMablaghBardashtCard != null
      );
    },
    hasPayaDailyLimit() {
      return (
        this.Resultcmb &&
        this.Resultcmb !== -1 &&
        this.Resultcmb.maxMablaghBardashtPaya != null
      );
    },
    showDailyLimitInfo() {
      if (!this.Resultcmb || this.Resultcmb === -1) return false;
      if (this.NoeEnteghal === "Card") return this.hasCardDailyLimit;
      if (this.NoeEnteghal === "Sheba" || this.NoeEnteghal === "Satna")
        return this.hasPayaDailyLimit;
      return false;
    },
    withdrawable() {
      const r = this.Resultcmb;
      if (!r || r === -1) return null;
      const value = r.ghabelBardasht + r.sumMabTaeedNaShode;
      return isNaN(value) ? null : value;
    },
    dailyLimit() {
      if (!this.showDailyLimitInfo) return null;
      const r = this.Resultcmb;
      let title, max, used;
      if (this.NoeEnteghal === "Card") {
        title = "کارت به کارت";
        max = r.maxMablaghBardashtCard;
        used = r.mabBardashtCardInDay;
      } else if (this.NoeEnteghal === "Sheba") {
        title = "پایا";
        max = r.maxMablaghBardashtPaya;
        used = r.mabBardashtPayaInDay;
      } else {
        title = "ساتنا";
        max = r.maxMablaghBardashtPaya;
        used = r.mabBardashtSatnaInDay;
      }
      max = Number(max);
      used = Number(used || 0);
      const percent =
        max > 0 ? Math.min(100, Math.round((used / max) * 100)) : 100;
      return {
        title,
        max,
        used,
        remaining: Math.max(0, max - used),
        percent,
        level: percent >= 90 ? "danger" : percent >= 70 ? "warn" : "ok",
      };
    },
  },
  methods: {
    toggleSavedList() {
      this.KEY++;
      this.GetDataShebaOrCard();
      this.SearchShebaOrCard = "";
      this.ShowList = !this.ShowList;
    },
    fillMaxAmount() {
      if (this.withdrawable > 0) {
        this.MabBardasht = String(this.withdrawable);
      }
    },
    CheckIfDelayed(accountInfo) {
      if (this.$session.get("CustCode") == "948") {
        if (
          this.Resultcmb.withdrawalIfLoanIsDelayed &&
          this.$session.get("moavaghatNoeId")
        ) {
          if (
            this.$session
              .get("moavaghatNoeId")
              .includes(accountInfo.wwwtblNoeId)
          ) {
            this.$mySweetDefault(
              "خطا",
              "این حساب داری اقساط معوقه می‌باشد و امکان برداشت از آن وجود ندارد",
              "error",
              2500,
            );
            this.Resultcmb = -1;
          }
        }
      }
    },
    onCaptchaValid({ valid, captchaId, userInput }) {
      this.CaptchaValid = valid;
      this.captchaId = captchaId;
      this.captchaText = userInput;
    },
    refreshCaptcha() {
      this.$refs.captchaRef.generateCaptcha();
    },
    SabtBardasht(id) {
      //console.log(this.ShebaNo);

      if (this.$session.get("CustCode") != 801) {
        if (this.MabBardasht.replace(/,/g, "").length < 4) {
          this.$mySweetDefault(
            "خطا",
            "مبلغ برداشت نمی تواند کمتر از 10,000 " +
              this.$GetVahedPool() +
              " یا خالی باشد",
            "error",
            2500,
          );
          this.refreshCaptcha();
          return;
        }

        if (this.NoeEnteghal == "Card") {
          if (this.$session.get("CustCode") != 934) {
            this.ShebaNo = "";
          }
          this.CardNo =
            this.First4Digit +
            this.Second4Digit +
            this.Third4Digit +
            this.Forth4Digit;
          if (this.CardNo.length != 16) {
            this.$mySweetDefault(
              "خطا",
              "شماره کارت صحیح نمیباشد",
              "error",
              2500,
            );
            this.refreshCaptcha();
            return;
          }
        } else {
          if (this.$session.get("CustCode") != 934) {
            this.CardNo = "";
          }
          if (this.ShebaNo == null || this.ShebaNo.length != 24) {
            this.$mySweetDefault(
              "خطا",
              "شماره شبا صحیح نمیباشد",
              "error",
              2500,
            );
            this.refreshCaptcha();
            return;
          }
        }
        if (this.NameSahebHesab.length < 1) {
          if (this.$GetIsEstelamSheba() === "true") {
            this.Estelam();
            return;
          }
          this.$mySweetDefault(
            "خطا",
            "نام صاحب حساب وارد نشده است",
            "error",
            2500,
          );
          this.refreshCaptcha();
          return;
        }
      }
      if (this.$session.get("CustCode") == 934 && this.disable == false) {
        this.$mySweetDefault(
          "خطا",
          "استعلام شماره کارت انجام نشده است ، ابتدا شماره کارت را به صورت صحیح وارد کرده و مجدد تلاش کنید",
          "error",
          3000,
        );
        this.refreshCaptcha();
        return;
      }
      if (this.$GetIsEstelamSheba() === "true" && this.ShowEstelam == false) {
        this.$mySweetDefault(
          "خطا",
          "استعلام شماره شبا انجام نشده است ، ابتدا شماره شبا را به صورت صحیح وارد کرده و مجدد تلاش کنید",
          "error",
          3000,
        );
        this.refreshCaptcha();
        return;
      }
      if (
        Number(this.MabBardasht.replace(/,/g, "")) <=
        this.Resultcmb.ghabelBardasht + this.Resultcmb.sumMabTaeedNaShode
      ) {
        if (!this.checkDailyLimit()) {
          return;
        }
        var NameSahebHesab =
          this.$session.get("CustCode") != 801
            ? this.NameSahebHesab
            : this.$session.get("UserInfoNetPa").ozvName +
              " " +
              this.$session.get("UserInfoNetPa").ozvFamily;
        if (this.$session.get("CustCode") == 934) {
          this.$SweetQustion(
            "اطمینان از برداشت وجه",
            " از برداشت وجه به مبلغ " +
              this.$Comma3ragham(Number(this.MabBardasht.replace(/,/g, ""))) +
              this.$GetVahedPool() +
              "  به شماره شـــبا یا شماره کــــارت " +
              this.CardNo +
              "  به نام آقا | خانم " +
              NameSahebHesab +
              " اطمینان دارید ؟ ",
            "question",
            "تایید برداشت",
            "انصراف",
            id,
            this.checkSms,
            this.isNotConfirmed,
          );
        } else {
          this.$SweetQustion(
            "اطمینان از برداشت وجه",
            " از برداشت وجه به مبلغ " +
              this.$Comma3ragham(Number(this.MabBardasht.replace(/,/g, ""))) +
              this.$GetVahedPool() +
              "  به شماره شـــبا یا شماره کــــارت " +
              this.CardNo +
              this.ShebaNo +
              "  به نام آقا | خانم " +
              NameSahebHesab +
              " اطمینان دارید ؟ ",
            "question",
            "تایید برداشت",
            "انصراف",
            id,
            this.checkSms,
            this.isNotConfirmed,
          );
        }
      } else {
        this.$mySweetDefaultTost(
          "خطا",
          "مبلغ برداشت نمیتواند بیشتر از مبلغ قابل برداشت باشد حساب باشد",
          "warning",
          2000,
        );
        this.refreshCaptcha();
        return;
      }
    },
    checkDailyLimit() {
      if (!this.Resultcmb || this.Resultcmb === -1) return true;
      const mablagh = Number(this.MabBardasht.replace(/,/g, ""));
      if (this.NoeEnteghal === "Card" && this.hasCardDailyLimit) {
        const used = Number(this.Resultcmb.mabBardashtCardInDay || 0);
        const max = Number(this.Resultcmb.maxMablaghBardashtCard);
        if (mablagh + used > max) {
          this.$mySweetDefaultTost(
            "خطا",
            "مبلغ برداشت به همراه برداشت‌های امروز کارت به کارت از سقف روزانه بیشتر است. باقیمانده سقف: " +
              this.$Comma3ragham(Math.max(0, max - used)),
            "warning",
            5500,
          );
          this.refreshCaptcha();
          return false;
        }
      } else if (this.NoeEnteghal === "Sheba" && this.hasPayaDailyLimit) {
        const used = Number(this.Resultcmb.mabBardashtPayaInDay || 0);
        const max = Number(this.Resultcmb.maxMablaghBardashtPaya);
        if (mablagh + used > max) {
          this.$mySweetDefaultTost(
            "خطا",
            "مبلغ برداشت به همراه برداشت‌های امروز پایا از سقف روزانه بیشتر است. باقیمانده سقف: " +
              this.$Comma3ragham(Math.max(0, max - used)),
            "warning",
            5500,
          );
          this.refreshCaptcha();
          return false;
        }
      } else if (this.NoeEnteghal === "Satna" && this.hasPayaDailyLimit) {
        const used = Number(this.Resultcmb.mabBardashtSatnaInDay || 0);
        const max = Number(this.Resultcmb.maxMablaghBardashtPaya);
        if (mablagh + used > max) {
          this.$mySweetDefaultTost(
            "خطا",
            "مبلغ برداشت به همراه برداشت‌های امروز ساتنا از سقف روزانه بیشتر است. باقیمانده سقف: " +
              this.$Comma3ragham(Math.max(0, max - used)),
            "warning",
            5500,
          );
          this.refreshCaptcha();
          return false;
        }
      }
      return true;
    },
    jumpTo(id) {
      document.getElementById(id).focus();
    },
    checkSms() {
      if (this.$session.get("CustCode") == "255") {
        this.sendTwoStepCode();
      } else this.ConfirmBardasht();
    },
    sendTwoStepCode() {
      this.twoLevel = true;
      var DataAxiosSms = {
        Method: "GET",
        Token: this.$session.get("TokenNetPa"),
        Action:
          "twoStepVerification?wwwtblAzaId=" +
          this.$session.get("UserInfoNetPa").wwwtblAzaId,
        ArryfildValue: null,
      };
      this.$PostData(DataAxiosSms).then((result) => {
        if (result.status == "success") {
          this.$mySweetDefaultTost("", result.msg, "success", 2800);
        }
      });
    },
    CheckCode() {
      var DataAxiosCheckCode = {
        Method: "POST",
        Token: this.$session.get("TokenNetPa"),
        Action: "twoStepVerification",
        ArryfildValue: {
          wwwtblAzaId: this.$session.get("UserInfoNetPa").wwwtblAzaId,
          Code: this.twstepCode + "",
        },
      };
      this.$PostData(DataAxiosCheckCode).then((result) => {
        if (result.status) {
          this.ConfirmBardasht();
        } else {
          this.$mySweetDefaultTost(
            "خطا",
            "رمز دو مرحله ای وارد شده صحیح نمیباشد. دوباره تلاش کنید",
            "error",
            2800,
          );
        }
      });
    },
    ConfirmBardasht(id) {
      if (this.SaveShebaOrCard == true) {
        this.SaveDataShebaOrCard().then((data) => {
          if (data == true) {
            this.$mySweetDefaultTost(
              "عملیات موفق",
              "ذخیره اطلاعات شبا و یا کارت با موفقیت انجام گردید",
              "success",
              2000,
            );
          } else {
            this.$mySweetDefaultTost(
              "عملیات ناموفق",
              "ذخیره اطلاعات شبا و یا کارت با خطا روبه رو شد",
              "danger",
              2000,
            );
          }
        });
      }
      this.loadingRender = true;
      var Mablagh = this.MabBardasht.replace(/,/g, "");
      var NameSahebHesab =
        this.$session.get("UserInfoNetPa").ozvName +
        " " +
        this.$session.get("UserInfoNetPa").ozvFamily;
      var ShebaIR = "";
      //console.log('/**/*/*/*/',this.ShebaNo);

      if (
        this.ShebaNo != null &&
        this.ShebaNo != "" &&
        this.ShebaNo != undefined
      ) {
        ShebaIR = "IR" + this.ShebaNo;
        //console.log('/**/*/*/*/',ShebaIR);
      }
      const formData = new FormData();
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      formData.append("wwwtblTaahodatIdBestanKar", 0);
      formData.append("wwwtblTaahodatIdBedehKar", id ? id : this.Resultcmb.id);
      formData.append("Mablagh", Mablagh);
      formData.append(
        "Desc",
        this.Description.trim() == ""
          ? "درخواست برداشت از حساب"
          : " درخواست برداشت : " + this.Description,
      );
      formData.append("KodRahgiri", "");
      formData.append(
        "CardNo",
        this.$session.get("CustCode") != 801 ? this.CardNo : "",
      );
      formData.append(
        "ShebaNo",
        this.$session.get("CustCode") != 801 ? ShebaIR : "",
      );
      formData.append(
        "NameSahebHesab",
        this.$session.get("CustCode") != 801
          ? this.NameSahebHesab
          : NameSahebHesab,
      );
      formData.append("EnteghalNoe", 6);
      formData.append("HesabNo", "");
      formData.append("OrderId", "-2");
      formData.append("MabKarmozdEnteghal", 0);
      formData.append("MabKarmozdBnp", 0);
      formData.append(
        "BankName",
        this.$session.get("CustCode") != 801 ? this.BankName : "",
      );
      formData.append("ComboIdGrp324", "");
      formData.append("TarixSanad", this.$store.state.JalaliDate);
      if (this.NoeEnteghal == "Sheba") {
        // Sheba همان پایا هست
        formData.append("tblcombiId330NoeEnteghal", 7384);
      } else if (this.NoeEnteghal == "Satna") {
        formData.append("tblcombiId330NoeEnteghal", 7385);
      } else {
        formData.append("tblcombiId330NoeEnteghal", 7386);
      }
      formData.append("userInput", this.captchaText);
      formData.append("captchaId", this.captchaId);

      // formData.append('tblBankId', this.tblBankId)
      this.DataAxios.ArryfildValue = formData;

      this.$PostFormData(this.DataAxios).then((data) => {
        if (data.success == "SUCCESS") {
          document.getElementById("CloseModal").click();
          this.$mySweetDefault(
            "درخواست موفقیت آمیز",
            "درخواست برداشت با موفقیت انجام شد،کدرهگیری شما:" +
              data.codeRahgiri,
            "success",
            7000,
          );
          this.loadingRender = false;
          this.$router.push({ name: "DebtorReport" });
          // checkIn
        } else if (data.success == "Failed") {
          this.loadingRender = false;
          this.$mySweetDefaultTost(
            "انتقال ناموفق",
            data.message,
            "warning",
            3000,
          );
          this.refreshCaptcha();
        } else {
          this.loadingRender = false;
          this.$mySweetDefaultTost(
            "خطا",
            "در برداشت از حساب مشکلی پیش آمده لطفا مجددا تلاش کنید",
            "warning",
            2000,
          );
          this.refreshCaptcha();
        }
      });
    },
    SaveDataShebaOrCard() {
      return new Promise((success, reject) => {
        let Data = {
          Id: 0,
          wwwtblAzaId: this.$session.get("UserInfoNetPa").wwwtblAzaId,
          IsSheba: this.NoeEnteghal == "Card" ? false : true,
          SahebShebaOrCard: this.NameSahebHesab,
          ShebaOrCardNum: this.CardNo.length > 0 ? this.CardNo : this.ShebaNo,
          IsBardasht: true,
          IsEstelamOnline: this.ShowEstelam == true ? true : false,
        };
        var DataAxiosFindShebaOrCard = {
          ArryfildValue: Data,
          Method: "Post",
          Action: "ShebaOrCard",
          Token: this.$session.get("TokenNetPa"),
        };
        this.$PostData(DataAxiosFindShebaOrCard).then((data) => {
          if (data.status == "Success") {
            success(true);
          }
          // else if(data.status == 'Dup') {
          //   //اطلاعات شبا و یا کارت تکراری بوده
          // }
          else {
            //خطا در ذخیره
          }
        });
      });
    },
    GetDataShebaOrCard() {
      var DataAxios = {
        ArryfildValue: "",
        Method: "post",
        Action: "ShebaOrCard/GetShebaOrCard",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      DataAxios.ArryfildValue = formData;
      this.$PostFormData(DataAxios).then((data) => {
        // console.log('data',data);

        data.forEach((value) => {
          value["select"] = false;
        });

        this.ListCard = data.filter(
          (x) => x.isSheba == false && x.isBardasht == true,
        );
        this.ListSheba = data.filter(
          (x) => x.isSheba == true && x.isBardasht == true,
        );
      });
    },
    SelectShebaOrCard(id, isSheba) {
      if (isSheba) {
        this.ListSheba.forEach((el) => {
          if (el.id == id) {
            el.selected = true;
            this.ShebaNo = el.shebaOrCardNum;
            this.NameSahebHesab = el.sahebShebaOrCard;
            this.ShowEstelam = true;
            this.KEY++;
          } else {
            el.selected = false;
          }
        });
      } else {
        this.ListCard.forEach((el) => {
          if (el.id == id) {
            el.selected = true;
            this.First4Digit = el.shebaOrCardNum.slice(0, 4);
            this.Second4Digit = el.shebaOrCardNum.slice(4, 8);
            this.Third4Digit = el.shebaOrCardNum.slice(8, 12);
            this.Forth4Digit = el.shebaOrCardNum.slice(12, 16);
            this.NameSahebHesab = el.sahebShebaOrCard;
            this.KEY++;
            this.EstelamCart();
            this.checkBankName();
          } else {
            el.selected = false;
          }
        });
      }
      this.ShowList = false;
    },
    RemoveShebeOrCard(row) {
      this.$SweetQustion(
        "اطمینان ازحذف",
        " از حذف شماره شبا و یا شماره کارت " +
          row.shebaOrCardNum +
          " به نام  " +
          row.sahebShebaOrCard +
          " اطمینان دارید ؟ ",
        "question",
        "تایید حذف",
        "انصراف",
        row.id,
        this.ConfirmRemoveShebaOrCard,
        this.isNotConfirmed,
      );
    },
    ConfirmRemoveShebaOrCard(id) {
      var DataAxios = {
        ArryfildValue: "",
        Method: "Post",
        Action: "ShebaOrCard/DeleteShebaOrCard",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append("wwwtbShebaOrCardId", id);
      DataAxios.ArryfildValue = formData;
      this.$PostFormData(DataAxios).then((data) => {
        if (data.status == "Success") {
          this.GetDataShebaOrCard();
          this.KEY++;
          this.$mySweetDefaultTost(
            "حذف موفق",
            " حذف شماره شبا یا شماره کارت انتخابی شما با موفقیت انجام شد",
            "success",
            2000,
          );
        }
      });
    },
    isNotConfirmed() {},
    Estelam() {
      this.loadingRender = true;

      var data = {
        CustCode: this.$session.get("CustCode"),
        Sign: "",
        IbanNumber: "IR" + this.ShebaNo,
      };
      var EstelamAxios = {
        action: "EstelamSheba/Index",
        method: "POST",
        arryfildValue: data,
      };

      this.$PostData_netpatoken(EstelamAxios)
        .then((result) => {
          console.log("/*/*/*/*/*/", result);

          if (typeof result == "string" || result.isSuccess == false) {
            var message = result == "string" ? result : result.message;
            this.$mySweetDefault("خطا", message, "error", 2000);
          } else {
            this.EstelamData.accountNumber = result.accountNumber;
            this.EstelamData.holders = result.ibanAccountOwnerList;
            this.EstelamData.accountComment = result.accountComment;
            this.EstelamData.bankCode = result.bankCode;
            this.EstelamData.bankName = result.bankName;
            this.BankName = result.bankName;
            this.ShowEstelam = true;
            this.ShowList = false;
            this.NameSahebHesab = "";
            this.EstelamData.holders.forEach((person) => {
              this.NameSahebHesab =
                this.NameSahebHesab + person.firstName + " " + person.lastName;
              this.SaveShebaOrCard = true;
            });
          }
        })
        .finally(() => {
          this.loadingRender = false;
        });
    },
    getSelectedBank(data) {
      this.tblBankId = data.bnpcashDbId;
    },
    checkBankName() {
      if (
        this.$session.get("CustCode") == 934 ||
        this.$session.get("CustCode") == 8002
      ) {
        let cart = "";
        let Bnk;
        if (this.Second4Digit.length == 2) {
          cart = this.First4Digit + "-" + this.Second4Digit;
          Bnk = this.listBank.find((x) => x.code == cart);
          if (Bnk != undefined) {
            this.isLicenseDebtor = true;
            this.bankSelected = Bnk;
            document
              .querySelector("#Bank")
              .classList.replace("d-none", "d-block");
            document
              .querySelector("#BankName")
              .classList.replace("d-none", "d-block");
            document
              .querySelector("#Error")
              .classList.replace("d-block", "d-none");
            document.querySelector("#BankName").classList.add("BankName");
          } else {
            this.isLicenseDebtor = false;
            document
              .querySelector("#Error")
              .classList.replace("d-none", "d-block");
          }
        } else if (this.Second4Digit.length < 2) {
          this.isLicenseDebtor = false;
          document
            .querySelector("#Bank")
            .classList.replace("d-block", "d-none");
          document
            .querySelector("#BankName")
            .classList.replace("d-block", "d-none");
          document
            .querySelector("#Error")
            .classList.replace("d-block", "d-none");
          document.querySelector("#BankName").classList.remove("BankName");
        }
      }
    },
    EstelamCart() {
      // jumpTo('NameSahebHesab')
      if (
        this.$session.get("CustCode") == 934 ||
        (this.$session.get("CustCode") == 8002 && this.isLicenseDebtor == true)
      ) {
        this.CardNo =
          this.First4Digit +
          this.Second4Digit +
          this.Third4Digit +
          this.Forth4Digit;
        if (this.CardNo.length == 16) {
          this.loadingRender = true;
          let data = {
            BnpInfo: {
              CustCode: this.$session.get("CustCode"),
              BankId: "",
              ClientId: "",
              ClientSecret: "",
            },
            bank: "",
            nationalCode: "",
            sourceAccount: "",
            cardNumber: this.CardNo,
          };
          var EstelamAxios = {
            action: "EnteghalVajh/EstelamCartNumber",
            method: "POST",
            arryfildValue: data,
          };
          this.$PostData_netpatoken(EstelamAxios).then((res) => {
            // console.log(res);

            this.loadingRender = false;
            if (res && res.status == true) {
              this.disable = true;
              this.NameSahebHesab = res.data.respObject.ownerName;
              this.BankName = "BSP";
              this.ShebaNo = res.data.respObject.iban.replace(/IR/g, "");
              this.$mySweetDefault(
                "استعلام موفق",
                "استعلام شماره کارت با موفقیت انجام شد",
                "success",
                2500,
              );
            } else {
              this.isLicenseDebtor = false;
              this.First4Digit = "";
              this.Second4Digit = "";
              this.Third4Digit = "";
              this.Forth4Digit = "";
              this.$mySweetDefault(
                "خطا",
                "خطایی در استعلام شماره کارت رخ داد لطفا  دقایق دیگر امتحان کنید",
                "error",
                2500,
              );
              return;
            }
          });
        } else {
          this.isLicenseDebtor = false;
          this.First4Digit = "";
          this.Second4Digit = "";
          this.Third4Digit = "";
          this.Forth4Digit = "";
          this.$mySweetDefault("خطا", "شماره کارت صحیح نمیباشد", "error", 2500);
          return;
        }
      } else {
        this.jumpTo("NameSahebHesab");
      }
    },
  },
  mounted() {
    if (
      this.$session.get("CustCode") == 561 ||
      this.$session.get("CustCode") == 866 ||
      this.$session.get("CustCode") == 948 ||
      this.$session.get("CustCode") == 953
    ) {
      this.NoeEnteghal = "Sheba";
    } else if (this.$session.get("CustCode") == 934) {
      this.NoeEnteghal = "Card";
    }

    // this.$refs.txtMablagh.focus()
    const formData = new FormData();
    let info;
    formData.append(
      "wwwtblAzaId",
      this.$session.get("UserInfoNetPa").wwwtblAzaId,
    );
    formData.append("wwwtblSarfaslTypeId", 2);
    this.DataAxios_cmbTaahodat.ArryfildValue = formData;
    this.$PostFormData(this.DataAxios_cmbTaahodat)
      .then((data) => {
        this.IsLoad = true;
        this.ListModel = data.filter((x) => x.tblSarfaslTypeId != 6);
        this.Resultcmb = data[0];
        this.Resultcmb = -1;
        this.withdrawalIfLoanIsDelayed =
          this.Resultcmb.withdrawalIfLoanIsDelayed;
      })
      .finally(() => {
        const formData = new FormData();
        formData.append(
          "wwwtblAzaId",
          this.$session.get("UserInfoNetPa").wwwtblAzaId,
        );
        formData.append("wwwtblSarfaslTypeId", 2);
        this.DataAxios_SahebHesab.ArryfildValue = formData;
        this.$PostFormData(this.DataAxios_SahebHesab).then((data) => {
          if (data.length > 0) {
            this.IsLoad = true;
            this.ListModelSahebHesab = data;
            for (
              let index = 0;
              index < this.ListModelSahebHesab.length;
              index++
            ) {
              if (this.ListModelSahebHesab[index].mande > 0) {
                info = this.ListModelSahebHesab[index];
                this.ListModel.push(info);
              }
            }
          }
          if (this.TaahodatId) {
            this.ListModel.forEach((e) => {
              if (e.id == this.TaahodatId) {
                this.Resultcmb = e;
              }
            });
          }
        });
      });
  },
  created() {},
};
</script>
<style scoped>
#Debtor {
  --d-primary: #435ebe;
  --d-primary-soft: #eef1fb;
  --d-primary-dark: #34499a;
  --d-border: #e3e7f1;
  --d-text: #2b3245;
  --d-muted: #6b7491;
  --d-success: #1f9d6b;
  --d-warning: #e0932b;
  --d-danger: #d64545;
  --d-radius: 14px;
}

/* ---------- Layout (single flat form) ---------- */
.Debtor-form {
  max-width: 560px;
  margin: 0 auto;
  padding: 0.5rem 0;
  color: var(--d-text);
}
/* ---------- Fields ---------- */
.Debtor-field {
  margin-bottom: 1rem;
}
.Debtor-field:last-child {
  margin-bottom: 0;
}
.Debtor-label {
  display: block;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--d-muted);
  margin-bottom: 0.4rem;
}
.Debtor-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-bottom: 0.4rem;
}
.Debtor-label-row .Debtor-label {
  margin-bottom: 0;
}
.Debtor-form .form-control {
  height: 46px;
  border-radius: 10px;
  border: 1px solid var(--d-border);
  background: #fafbfe;
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease,
    background 0.15s ease;
}
.Debtor-form .form-control:focus {
  background: #fff;
  border-color: var(--d-primary);
  box-shadow: 0 0 0 3px rgba(67, 94, 190, 0.15);
}
.Debtor-form .form-control:disabled {
  background: #f0f2f8;
  color: var(--d-muted);
}
.Debtor-form textarea.form-control {
  height: auto;
}
.Debtor-form input[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
}
.Debtor-form input[type="number"]::-webkit-outer-spin-button,
.Debtor-form input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.Debtor-note {
  display: block;
  margin-top: 0.4rem;
  color: var(--d-warning);
  font-size: 0.78rem;
}
.Debtor-skeleton {
  height: 46px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0 0.9rem;
  border-radius: 10px;
  background: #f0f2f8;
  color: var(--d-muted);
  font-size: 0.875rem;
}

.Debtor-link-btn {
  background: none;
  border: 0;
  padding: 0;
  color: var(--d-primary);
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
}
.Debtor-link-btn:hover {
  color: var(--d-primary-dark);
  text-decoration: underline;
}

/* ---------- Balance & limit ---------- */
.Debtor-balance {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.95rem 1.1rem;
  border-radius: 12px;
  color: #fff;
  background: linear-gradient(135deg, #435ebe, #5f78d6);
}
.Debtor-balance.is-empty {
  background: linear-gradient(135deg, #a9b2cf, #c0c7de);
}
.Debtor-balance__label {
  font-size: 0.85rem;
  opacity: 0.9;
}
.Debtor-balance__value {
  font-size: 1.3rem;
  font-weight: 700;
  letter-spacing: 0.2px;
}
.Debtor-balance__value small {
  font-size: 0.75rem;
  font-weight: 500;
  opacity: 0.85;
  margin-right: 0.2rem;
}

.Debtor-limit {
  margin-top: 1rem;
  padding: 0.85rem 1rem;
  border: 1px solid var(--d-border);
  border-radius: 12px;
  background: #fafbfe;
  font-size: 0.82rem;
  color: var(--d-muted);
}
.Debtor-limit__head,
.Debtor-limit__meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}
.Debtor-limit__head b,
.Debtor-limit__meta b {
  color: var(--d-text);
}
.Debtor-progress {
  height: 8px;
  margin: 0.6rem 0;
  border-radius: 99px;
  background: #e6e9f3;
  overflow: hidden;
}
.Debtor-progress span {
  display: block;
  height: 100%;
  border-radius: inherit;
  transition: width 0.3s ease;
}
.Debtor-progress .is-ok {
  background: var(--d-success);
}
.Debtor-progress .is-warn {
  background: var(--d-warning);
}
.Debtor-progress .is-danger {
  background: var(--d-danger);
}
.Debtor-limit__remaining b {
  color: var(--d-primary);
}

/* ---------- Segmented control ---------- */
.Debtor-segmented {
  display: flex;
  gap: 0.25rem;
  padding: 0.25rem;
  border-radius: 12px;
  background: #eef0f7;
}
.Debtor-segment {
  position: relative;
  flex: 1 1 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  padding: 0.6rem 0.5rem;
  border-radius: 9px;
  color: var(--d-muted);
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  user-select: none;
  transition:
    background 0.15s ease,
    color 0.15s ease,
    box-shadow 0.15s ease;
}
.Debtor-segment input {
  position: absolute;
  opacity: 0;
  inset: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  cursor: pointer;
}
.Debtor-segment:hover {
  color: var(--d-text);
}
.Debtor-segment.is-active {
  background: #fff;
  color: var(--d-primary);
  box-shadow: 0 1px 4px rgba(35, 48, 90, 0.15);
}
.Debtor-segment:focus-within {
  outline: 2px solid rgba(67, 94, 190, 0.45);
  outline-offset: 1px;
}

/* ---------- Card number ---------- */
.Debtor-cardnum {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.5rem;
}
.Debtor-cardnum .form-control {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  font-size: 1.05rem;
  font-weight: 600;
  letter-spacing: 1px;
}
.Debtor-bank {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.6rem;
}
.Debtor-bank > div {
  font-size: 0.85rem;
}
.Debtor-bank > #Error {
  width: 100%;
}
.BankName {
  padding: 0.15rem 0.7rem;
  border: 1px dashed chocolate;
  border-radius: 6px;
  background: rgb(241, 231, 224);
  color: chocolate;
  text-align: center;
  font-weight: bold;
}

/* ---------- Sheba ---------- */
.Debtor-sheba {
  display: flex;
  align-items: stretch;
  gap: 0.5rem;
}
.Debtor-sheba__prefix {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  padding: 0 0.85rem;
  border-radius: 10px;
  background: var(--d-primary-soft);
  color: var(--d-primary);
  font-weight: 700;
  letter-spacing: 1px;
}
.Debtor-sheba .form-control {
  flex: 1 1 auto;
  min-width: 0;
  font-weight: 600;
  letter-spacing: 1px;
}
.Debtor-sheba__inquiry {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0 0.9rem;
  border: 0;
  border-radius: 10px;
  background: var(--d-primary);
  color: #fff;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease;
}
.Debtor-sheba__inquiry:hover {
  background: var(--d-primary-dark);
}
@media (max-width: 420px) {
  .Debtor-sheba__inquiry span {
    display: none;
  }
}

/* ---------- Saved list ---------- */
.Debtor-saved {
  margin-bottom: 1rem;
  padding: 0.85rem;
  border: 1px solid var(--d-border);
  border-radius: 12px;
  background: #f6f7fc;
}
.Debtor-saved__head {
  margin-bottom: 0.6rem;
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--d-text);
}
.Debtor-saved__list {
  max-height: 260px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.Debtor-saved__empty {
  padding: 1rem;
  text-align: center;
  color: var(--d-muted);
  font-size: 0.85rem;
}
.Debtor-saved__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.65rem 0.85rem;
  border: 1px solid var(--d-border);
  border-radius: 10px;
  background: #fff;
}
.Debtor-saved__item.is-selected {
  border-color: var(--d-success);
  background: #f2fbf7;
}
.Debtor-saved__info {
  min-width: 0;
}
.Debtor-saved__num {
  font-weight: 700;
  letter-spacing: 0.5px;
  word-break: break-all;
  text-align: right;
}
.Debtor-saved__num span {
  color: var(--d-warning);
  margin-left: 0.15rem;
}
.Debtor-saved__owner {
  font-size: 0.8rem;
  color: var(--d-muted);
}
.Debtor-saved__actions {
  flex: 0 0 auto;
  display: flex;
  gap: 0.35rem;
}
.Debtor-icon-btn {
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 8px;
  background: #eef0f7;
  color: var(--d-muted);
  cursor: pointer;
  transition:
    background 0.15s ease,
    color 0.15s ease;
}
.Debtor-icon-btn.is-select:hover {
  background: var(--d-primary);
  color: #fff;
}
.Debtor-icon-btn.is-remove:hover {
  background: var(--d-danger);
  color: #fff;
}
.Debtor-icon-btn.is-done {
  background: var(--d-success);
  color: #fff;
  cursor: default;
}

/* ---------- Inquiry result ---------- */
.Debtor-estelam {
  margin-bottom: 1rem;
  padding: 0.75rem 1rem;
  border: 1px solid #bfe6d4;
  border-radius: 12px;
  background: #f2fbf7;
  font-size: 0.85rem;
}
.Debtor-estelam__row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.35rem 0;
}
.Debtor-estelam__row + .Debtor-estelam__row {
  border-top: 1px dashed #cfe9dd;
}
.Debtor-estelam__row > span {
  flex: 0 0 auto;
  color: var(--d-muted);
}
.Debtor-estelam__row > b {
  text-align: left;
}
.Debtor-estelam__holders {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.3rem;
}
.Debtor-estelam__holders em {
  font-style: normal;
  font-weight: 700;
  padding: 0.1rem 0.55rem;
  border-radius: 99px;
  background: #fff;
  border: 1px solid #cfe9dd;
}

.Debtor-switch .custom-control-label {
  font-size: 0.875rem;
  color: var(--d-text);
}

/* ---------- Amount ---------- */
.Debtor-amount {
  position: relative;
}
.Debtor-form .Debtor-amount__input {
  height: 62px;
  padding-left: 4.5rem;
  padding-right: 1rem;
  font-size: 1.6rem !important;
  font-weight: 700;
  text-align: center;
  letter-spacing: 0.5px;
}
.Debtor-amount__unit {
  position: absolute;
  top: 50%;
  left: 1rem;
  transform: translateY(-50%);
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--d-muted);
  pointer-events: none;
}
.Debtor-amount__foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  min-height: 1.6rem;
  margin-top: 0.5rem;
}
.Debtor-amount__words {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--d-primary);
}

/* ---------- Submit ---------- */
.Debtor-submit {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  min-height: 54px;
  padding: 0.5rem 1.25rem;
  border: 0;
  border-radius: 12px;
  background: linear-gradient(135deg, #435ebe, #5770c9);
  color: #fff;
  font-size: 1.05rem;
  font-weight: 700;
  box-shadow: 0 6px 16px rgba(67, 94, 190, 0.3);
  cursor: pointer;
  transition:
    transform 0.1s ease,
    box-shadow 0.15s ease,
    opacity 0.15s ease;
}
.Debtor-submit:hover:not(:disabled) {
  box-shadow: 0 8px 20px rgba(67, 94, 190, 0.4);
  transform: translateY(-1px);
}
.Debtor-submit:disabled {
  background: #c5cbdd;
  box-shadow: none;
  cursor: not-allowed;
}
.Debtor-submit--sm {
  width: auto;
  min-height: 46px;
  padding: 0 1.5rem;
  font-size: 0.95rem;
  background: var(--d-success);
  box-shadow: none;
}
.Debtor-twostep {
  margin-top: 1.25rem;
  padding-top: 1.25rem;
  border-top: 1px dashed var(--d-border);
}
.Debtor-twostep__row {
  display: flex;
  gap: 0.5rem;
}
.Debtor-twostep__row .form-control {
  flex: 1 1 auto;
}

@media (max-width: 575px) {
  .Debtor-balance__value {
    font-size: 1.1rem;
  }
}
</style>
